import {Routes} from '@angular/router';
import {authGuard, getAuthRoutes} from '@ratespecial/logto-angular';
import {userResolver} from './shared/auth/resolvers/user.resolver';
import {rrHomeResolver} from 'src/app/modules/round-robin-billing/pages/rr-home/rr-home.resolve';
import {environment} from 'src/environments/environment';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'campaigns',
  },
  ...getAuthRoutes(environment.logto.routing),
  {
    path: '',
    pathMatch: 'prefix',
    canActivate: [authGuard],
    resolve: {
      user: userResolver,
    },
    children: [
      {path: '', pathMatch: 'prefix', loadComponent: () => import('./layout/navbar/navbar.component').then(m => m.NavbarComponent), outlet: 'header'},
      {path: '', pathMatch: 'prefix', loadComponent: () => import('./layout/footer/footer.component').then(m => m.FooterComponent), outlet: 'footer'},
      {path: '', pathMatch: 'full', redirectTo: 'campaigns'},

      {
        path: 'round-robin',
        children: [
          {
            path: '',
            pathMatch: 'prefix',
            redirectTo: 'home',
            data: {scrollToTag: 'dashTop'},
          },
          {
            path: 'home',
            loadComponent: () => import('src/app/modules/round-robin-billing/pages/rr-home/rr-home.component').then(m => m.RrHomeComponent),
            resolve: {
              productMap: rrHomeResolver,
            },
          },
        ],
      },

      {
        path: 'billing-cascade',
        pathMatch: 'prefix',
        children: [
          {
            path: '',
            pathMatch: 'prefix',
            children: [
              {path: 'afid-assignment', loadComponent: () => import('src/app/modules/billing-cascade/afid-assignment/afid-assignment-list/afid-assignment-list.component').then(m => m.AfidAssignmentListComponent)},
            ],
          },
        ],
      },

      {
        path: 'processor',
        pathMatch: 'prefix',
        children: [
          // To get nav highlight working on processor/<some-child> route, make a default for
          // processor/ since it's not actually mapped to any component redirect to processor/list
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'list',
          },
          {
            path: '',
            pathMatch: 'prefix',
            children: [
              {path: 'list', loadComponent: () => import('src/app/modules/processor/processor-list/processor-list.component').then(m => m.ProcessorListComponent)},
              {path: 'detail', loadComponent: () => import('src/app/modules/processor/processor-detail/processor-detail.component').then(m => m.ProcessorDetailComponent)},
            ],
          },
        ],
      },
      {
        path: 'account-updater',
        pathMatch: 'prefix',
        children: [
          {
            path: '',
            pathMatch: 'prefix',
            redirectTo: 'sticky',
            data: {scrollToTag: 'dashTop'},
          },
          {
            path: 'sticky',
            loadComponent: () => import('src/app/modules/account-updater/pages/sticky-io/sticky-io.component').then(m => m.StickyIoComponent),
          },
        ],
      },

      {
        path: 'campaigns',
        pathMatch: 'prefix',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'list',
          },
          {
            path: '',
            pathMatch: 'prefix',
            children: [
              {path: 'list', loadComponent: () => import('src/app/modules/campaigns/pages/campaign-list/campaign-list.component').then(m => m.CampaignListComponent)},
            ],
          },
        ],
      },

      {
        path: 'rdr-import',
        pathMatch: 'prefix',
        children: [
          {
            path: '',
            pathMatch: 'prefix',
            loadComponent: () => import('src/app/modules/rdr-import/pages/rdr-import-page/rdr-import-page.component').then(m => m.RdrImportPageComponent),
            data: {scrollToTag: 'dashTop'},
          },
        ],
      },

      {path: '**', loadComponent: () => import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)},
    ],
  },
];
